import React, { useEffect } from "react";
import "./Visson_Misson.css";
import Banner from "./banner/Banner";
import At_Our_Tapovan from "./at_our_tapovan/At_Our_Tapovan";
import Vission_Mission_Component from "./vission_mission_component/Vission_Mission_Component";
import Core_vision from "./core-vision/Core_vision";
import What_We_Do from "./what_we_do/What_We_Do";
import Dose_Of_Peace from "../home/dose_of_peace/Dose_Of_Peace";
import { useDispatch, useSelector } from "react-redux";
import { AtOmTapovan, BlogCategory, OurMission, OurVission } from "../../features/admin/common/Slice";
import { IDS } from "../../utils/IDS";

const Visson_Misson = () => {

  const dispatch = useDispatch();
  const data = useSelector((state) => state.common.at_om_tapovan);
  const visionData = useSelector((state) => state.common.our_vission);
  const missionData = useSelector((state) => state.common.our_mission);

  useEffect(() => {
    dispatch(AtOmTapovan());
    dispatch(OurVission());
    dispatch(OurMission());
  }, [dispatch]);
  return (
    <section className="Visson_Misson">
      <Banner image={IDS.IMG_URL + data?.At_Om_Tapovan?.image} />
      <At_Our_Tapovan data={data} />
      <Vission_Mission_Component visionData={visionData} missionData={missionData} />
      <Core_vision />
      <What_We_Do />
      <Dose_Of_Peace />
    </section>
  );
};

export default Visson_Misson;
